import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { Grade } from '@brighterly/lib-core-types/kid/enums'

/** `K4` → `Grade 4`, `K` → `Kindergarten`. The `K` prefix is the enum's own spelling. */
export const getGradeLabel = (value: Grade): string => {
  const number = String(value).replace(/^K/, '')

  return number === '' ? 'Kindergarten' : `Grade ${number}`
}

export const gradeOptions: AppSelectOption<Grade>[] = Object.values(Grade)
  .map(value => ({ value, text: getGradeLabel(value) }))
